import React from 'react';
import { I18n, Translate } from 'react-redux-i18n';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import logo from '../../../img/logo-idnot.png';
import Loader from '../../Loader';
import authApi from '../../../network/api/authApi';
import { getLinks } from '../../../network/api/links';
import Button from '../../common/Button';
import Footer from '../../layout/Footer';

type LocationState = {
  key: string,
  email:string,
};

type Props = RouteComponentProps<unknown, null, LocationState>;
enum Mode{
  wait,
  done,
  error
}
type State = {
  mode: Mode;
  mail: string;
};

class VerificationMail extends React.Component<Props, State> {
  state: State = {
    mode: Mode.wait,
    mail: '',
  };

  componentDidMount() {
    this.send();
  }

  send = () => {
    window.scrollTo(0, 0);
    this.setState({ mode: Mode.wait });
    authApi.authPhase4({ key: this.props.location.state.key, email: this.state.mail })
      .then((data) => {
        this.setState({ mode: Mode.done });
        this.setState({ mail: data.email });
      })
      .catch(() => this.setState({ mode: Mode.error }));
  };

  isModeWait = ():boolean => this.state.mode === Mode.wait;

  isModeDone = ():boolean => this.state.mode === Mode.done;

  isModeError = ():boolean => this.state.mode === Mode.error;

  render() {
    return (
      <div className="activation-link-page">
        <div className="activation-header">
          <div className="label-container">
            <div className="back-button">
              <a
                aria-label="Se connecter"
                href={getLinks().connectionLink}
              >
                <Button
                  type="third"
                  i18nKey="HEADER.CONNECTION"
                />
              </a>
            </div>
            <div className="main-content">
              <div>
                <img className="logo" src={logo} alt="logo" />
              </div>
              <div>
                <h3>
                  <Translate value="ACTIVATION.TITLE" />
                </h3>
                <div className="subtitle">
                  <Translate value="HEADER.UNIQUE_ACCOUNT" />
                </div>
              </div>
            </div>
            <div className="filler" />
          </div>
        </div>
        {
          this.isModeWait() && (
            <Loader />
          )
        }
        {this.isModeDone() && (
          <div className="email-page-content">
            <Translate value="VERIFY_EMAIL.EMAIL_SENT" mail={this.state.mail} />
            <Translate value="VERIFY_EMAIL.CLICK_ON_LINK" />
          </div>
        )}
        {this.isModeError() && (
        <div className="email-page-content">
          <Translate value="message.ERROR" />
          <Button
            type="primary"
            onClick={this.send}
            i18nKey="actions.RETRY"
          />
        </div>
        )}
        <Footer />
      </div>
    );
  }
}
export default withRouter(VerificationMail);
